import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/promotionTabOption'

export const promotionTabOptionService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    syncFirebase
};

function search(offset, max, dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data: dataFilter, showAlert: false})
}

function syncFirebase() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'GET', {})
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE', {})
}